import { FormFinancialLineItem, TrackingCodeMetadata } from '@fox/finance';
import { ReservationModel } from '../../form-event-context/contracts';
import { ConditionalDefinitions } from '../form-block/conditionals/contracts';
import { ProvidesSubQuestion } from '../question-block/contracts';

// If build fails this type import could be it just so I don't forget :D
export type TicketDefinition = EventsTicketsDefinition & {
	ticketCounts?: TicketCounts;
};

export type EventTickets = {
	definitions?: TicketDefinition[];
	enabled?: boolean;
};

export type TicketFieldProps = {
	required: boolean;
	labelOverrides: Record<string, string>;
	conditionalDefinitions: ConditionalDefinitions;
	allowedTickets: string[];
	name: string;
	min: number;
	max: number;
	type: string;
	allowQuantitySelection: boolean;
	provides?: Record<string, ProvidesSubQuestion>;
	title: string;
};

export type TicketProps = {
	id: string;
	tickets?: EventTickets;
};

export type TicketAnswer = {
	ticketId?: string;
	quantity?: number;
	createdTickets?: { id: number; description: string; invoiceId?: number }[];
};

export type TicketCounts = {
	ticketId: string;
	current: number;
	limit: number;
};

export type TicketAnswerData = {
	lineItems?: FormFinancialLineItem;
	reservation?: ReservationModel;
};

export const TICKET_RESERVATION_MESSAGE_KEY = 'event-ticket-reservation';

type EventsTicketsDefinition = {
	description?: string;
	financial?: FinancialInvoiceMetadata;
	id: string;
	name: string;
	price: number;
	public: boolean;
	current?: number;
	limit?: number;
	type: string;
	groupMultiplier?: number;
};

export type FinancialInvoiceMetadata = {
	account?: number | null;
	item?: number | null;
	taxInclusive?: boolean | null;
	taxRate?: number | null;
	trackingCodes?: TrackingCodeMetadata[];
};
